import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import StarredContentMenuQuery, {
	type StarredContentMenuQuery$data,
	type StarredContentMenuQuery$variables,
} from './__generated__/StarredContentMenuQuery.graphql.ts';
import { starredContentMenuQueryVars } from './starredContentMenuConstants.ts';

export function preloadStarredContentMenu() {
	return query<StarredContentMenuQuery$data, StarredContentMenuQuery$variables>({
		query: StarredContentMenuQuery,
		variables: starredContentMenuQueryVars,
		fetchPolicy: 'network-only',
	});
}
